<template>
  <el-dialog
    class="gen-user-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <!-- <el-form-item label="用户名称" prop="UserName">
        <el-input v-model="editForm.UserName" placeholder="请输入"></el-input>
      </el-form-item> -->

      <el-form-item label="用户身份标识（公钥）" prop="UserName">
        <template slot="label">
          <span
            >用户身份标识（公钥）
            <el-tooltip class="item" effect="dark" placement="right">
              <i class="el-icon-question common-icon" ></i>
              <div slot="content">
                <p>用于生成公钥的身份标识信息</p>
              </div>
            </el-tooltip>
          </span>
        </template>
        <el-input v-model="editForm.UserName"></el-input>
      </el-form-item>
      <el-form-item label="选择组织" prop="OrgId" >
        <el-select
          v-model="editForm.OrgId"
          placeholder="请选择"
          clearable
          class="auto-width"
          @change="handleSelect"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="密码算法" prop="Algorithm">
        <el-select
          v-model="editForm.Algorithm"
          placeholder="请选择"
          clearable
          class="auto-width"
          disabled
        >
          <el-option
            v-for="item in algoOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户角色" prop="UserRole">
        <el-select v-model="editForm.UserRole" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'GenUserCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 160
  },
  data() {
    return {
      disabled: false,
      title: '生成IBC用户证书',
      dialogVisible: false,
      editForm: {
        Algorithm: '',
        OrgId: '',
        OrgName: '',
        CertType: 2,
        UserRole: '',
        UserName: ''
      },
      editRules: {
        UserName: [
          { required: true, message: '请填写用户身份标识（公钥）', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9.-]+$/, message: '身份标识只能包含英文、数字、.和-', trigger: 'blur' }
        ],
        OrgId: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        UserRole: [{ required: true, message: '请选择用户角色', trigger: 'blur' }],
        Algorithm: [{ required: true, message: '请选择算法', trigger: 'blur' }],
        OrgName: [{ required: true, message: '请填写组织名称', trigger: 'blur' }]
      },
      options: [],
      algoOption: [
        { label: '国密', value: 0 },
        { label: 'ECDSA', value: 1 },
        { label: 'IBC', value: 2 }
      ],
      roleOptions: [
        { label: 'admin', value: 0 },
        { label: 'client', value: 1 },
        { label: 'light', value: 2 }
      ],
      adaptationVars: {
        formLabelWidth: 200
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getOrgList({ limit: 50, offset: 0, certType: 0 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.editForm = {
        OrgId: '',
        OrgName: '',
        UserRole: '',
        UserName: '',
        CertType: 2,
        Algorithm: ''
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleSelect(val) {
      let item = this.options.filter(ele => ele.OrgId === val)
      this.editForm.Algorithm = item[0].Algorithm
      this.editForm.OrgName = item[0].OrgName
    },
    handleOk() {
      const testResult = this.$utils.checkCertificateName(this.editForm.UserName)
      if (testResult) {
        this.$message.error(testResult)
        return
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate
            .genCert(this.editForm)
            .then(res => {
              if (res?.errors == null) {
                this.$message.success('生成用户证书成功！')
                this.$emit('update:list')
                this.handleCancel()
              }
            })
            .catch(err => {
              return
            })
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.gen-user-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .common-icon {
    vertical-align: middle;
    font-size: var(--common-dialogize);
  }
}
</style>
